/** State of processing by the CS team. */
export const SUPPLIER_REQUEST_STATE = [
  'pending',
  'created_new_company',
  'linked_to_existing_company',
  'rejected',
] as const;

/** Lifecycle of the search-agent enrichment job, separate from `state` (the CS decision). */
export const SUPPLIER_REQUEST_ENRICHMENT_STATUS = [
  'running',
  'completed',
  'failed',
] as const;

/** Status of the search-agent researched data. */
export const SUPPLIER_REQUEST_RESEARCHED_DATA_STATUS = [
  'resolved',
  'partial',
  'ambiguous',
  'not_found',
  'unavailable',
  'invalid',
] as const;

export const VOLUME_BUCKET = [
  '0-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '>5000',
] as const;

export const SUPPLIER_REQUEST_ACTION = ['create', 'link', 'reject'] as const;

export const SUPPLIER_REQUEST_ORDER_BY = [
  'requested_at',
  'supplier_name',
  'state',
] as const;
